import React from 'react';
import { FaBook } from 'react-icons/fa';
import { useToast } from 'src/hooks/Toast';
import FormComponent from 'src/pages/DashboardPages/core/components/FormComponent';
import { convertToXLSX, convertXlsxToJson } from 'src/utils/download';


import { useModal } from '../../../../../../../../hooks/Modal';

import api from '../../../../../../../../services/api';

interface ICreateModule {
    lineData: Record<string, any>;
}

export default function ReviewModule(): JSX.Element {

    const { addModal } = useModal();
    const { addToast } = useToast();


    const callInsert = async (list) => {


        const papers = await api.get('/cientific-submissions', { params: { limitItems: 100000 } })
        const editals = await api.get('/cientific-selection', { params: { limitItems: 100000 } })
        const avaliators = await api.get('/cientific-avaliators', { params: { limitItems: 100000 } })

        const uploadList: any = [];

        list.map(avaliation => {


            const paper = papers?.data?.rows?.find(i => i?._id?.toString() === avaliation?.paper_id);
            const edital = editals?.data?.rows?.find(i => i?._id?.toString() === avaliation?.selective_id);
            const avaliator = avaliators?.data?.rows?.find(i => i?._id?.toString() === avaliation?.avaliator_id);

            const item = {
                project_id: edital?.project_id,
                reference: avaliation?.reference,
                date: avaliation?.date,
                section: avaliation?.session,
                room: avaliation?.room,
                category: paper?.category,
                area: paper?.area,
                subarea: paper?.subarea,
                orientator: paper?.orientator,
                author: paper?.author,


                paper_id: paper?._id?.toString(),
                paper_id_response: {
                    _id: paper?._id?.toString(),
                    title: paper?.title
                },
                client_id: paper?.client_id,
                client_id_response: { ...paper?.client_id_response },


                avaliator_id: avaliator?._id?.toString(),
                avaliator_id_response: {
                    _id: avaliator?._id?.toString(),
                    name: avaliator?.name
                },

                selective_id: edital?._id?.toString(),
                selective_id_response: {
                    _id: edital?._id?.toString(),
                    title: edital?.title
                }


            }

            uploadList.push(item);


        })


        let x = 0;

        await api.post('/upload-avaliations-list', { data: uploadList });

        addToast({ title: `Concluído com sucesso`, type: 'info' })




    }


    const getData = async (data) => {
        console.log('Tipo do arquivo:', data.file instanceof File); // deve ser true
        console.log('Arquivo:', data.file);
        /*
        Here i need Avaliator ID, Edital ID, Date, Session, room*/

        const formData = new FormData();
        formData.append('file', data.file);



        const dataList = await api.post(`/converter/xlsx-to-json`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        callInsert(dataList?.data?.rows)

    }


    const handleCreate = (): void => {
        const content = (
            <input
                type="file"
                onChange={(e) => {
                    const file = e.target.files?.[0];
                    if (file) {
                        getData({ file }); // agora sim, data.file existe
                    }
                }}
            />
        );
        if (content) {
            const keyModal = addModal({ title: 'Adicionar usuários', content, key: 'modal', theme: "whiteModal" });
        }
    };


    const moduleCreate = (): JSX.Element => {

        return <button title='Substituir Avaliações' className='searchButton' onClick={() => handleCreate()}  >

            <FaBook className="hover" style={{ cursor: 'pointer' }} />

        </button>;
    }



    return moduleCreate();
}
